import { combineReducers } from "redux";
import dashboard from "./dashboardReducer";

const rootReducer = () =>
  combineReducers({
    dashboard: dashboard,
  });

export default rootReducer;
